<template>
  <custom-dialog
    :show="show"
    :title="$t('dialog.open.viewDevice')"
    @toggleShow="handleClose"
    :appendToBody="true"
    width="70%"
  >
    <div class="form" slot="main">
      <div
        style="
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <div style="display: flex; align-items: center; max-width: 400px">
          <!-- <div style="margin-left: 40px; min-width: 100px">特殊字段检索</div> -->
          <!-- <el-input
            v-model="value"
            size="small"
            placeholder="特殊字段是否为空"
          ></el-input> -->
        </div>
        <div class="operate-btn">
          <!-- <el-button
            type="primary"
            class="btn"
            size="small"
            @click="search_list"
            >{{ $t("label.open.query") }}</el-button
          >
          <el-button
            type="success"
            class="btn"
            size="small"
            @click="export_out"
            >{{ $t("label.open.export") }}</el-button
          >
          <el-button
            type="warning"
            class="btn"
            size="small"
            @click="import_btn"
            >{{ $t("label.open.import") }}</el-button
          > -->
          <el-button
            type="danger"
            class="btn"
            size="small"
            @click="delete_batch"
            >{{ $t("label.open.delete_btn") }}</el-button
          >
        </div>
      </div>
      <div class="table">
        <el-table
          :data="tableData"
          ref="tableData"
          stripe
          @selection-change="handleSelectionChange"
          :height="tableHeight"
        >
          <el-table-column align="center" type="selection" width="55">
          </el-table-column>
          <!-- <el-table-column align="center" width="55">
            <template scope="scope">
              <el-radio
                :label="scope.$index"
                v-model="radio"
                @change.native="getCurrentRow(scope.row)"
              ></el-radio>
            </template>
          </el-table-column> -->
          <el-table-column
            v-for="column in columns"
            :key="column"
            :prop="column"
            :label="$t(`label.open.${column}`)"
            align="center"
            :min-width="column == 'operate' ? '150px' : '100px'"
          >
            <template slot-scope="{ row }">
              <template v-if="column == 'status'">
                <span v-if="row.status === 1" style="color: #3e916a">
                  {{ $t("label.receiverList.link") }}
                </span>
                <span v-else style="color: #ce0000">
                  {{ $t("label.receiverList.break") }}
                </span>
              </template>
              <template
                v-else-if="column == 'device_manage' || column == 'data_push'"
              >
                <el-button
                  type="success"
                  size="small"
                  @click="operateBtn(column)"
                  >{{
                    column == "device_manage"
                      ? $t("label.open.add_btn")
                      : $t("label.open.push_btn")
                  }}</el-button
                >
              </template>
              <template v-else>
                {{ row[column] }}
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          :total="total"
          popper-class="mySelectType"
          :current-page="page"
          @size-change="sizeChange"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </div>

    <div class="flex btns" slot="footer">
      <el-button
        type="success"
        class="btn cancel"
        size="small"
        @click="handleClose()"
      >
        {{ $t("public.close") }}
      </el-button>
      <el-button type="primary" class="btn save" size="small" @click="add">
        {{ $t("public.save") }}
      </el-button>
    </div>
  </custom-dialog>
</template>

<script>
import { getDeviceList, addThirdDevice, batchDeleteDevice } from "@/api/index";
import CustomDialog from "../../../components/public/customDialog";
import indexCompany from "../company/index";
export default {
  name: "EditSn",
  components: {
    CustomDialog,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    // 校验账号
    var validateSN = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入账号"));
      } else {
        callback();
      }
    };
    return {
      radio: false,
      value: "",
      page: 1,
      total: 0,
      pageSize: 10,
      tableData: [],
      tableHeight: 450,
      choose: [],
      templateSelection: "",
      formItem: [
        {
          label: "dialog.userList.query_sn",
          key: "sn",
          inputType: "input",
        },
      ],
      form: {
        sn: "",
      },
      rules: {
        sn: [{ required: true, validator: validateSN, trigger: "blur" }],
      },
      columns: ["index", "sn", "method", "created_time"],
    };
  },
  computed: {
    title() {
      if (this.rowInfo && this.rowInfo.id) {
        return this.$t("dialog.userList.edit_title") + "-" + this.rowInfo.name;
      } else {
        return this.$t("dialog.userList.add_title");
      }
    },
    currentFormItem() {
      if (this.rowInfo && this.rowInfo.id) {
        return this.formItem.filter(
          (f) => f.key == "accountType" || f.key == "contact"
        );
      } else {
        return this.formItem;
      }
    },
  },
  watch: {
    show: {
      handler(val) {
        this.form = {
          sn: "",
        };
        if (val) {
          this.search_list();
        }
      },
      deep: true,
    },
    row: {
      handler(newVal) {
        if (newVal && indexCompany) {
          if (indexCompany["table_" + newVal.id]) {
            this.columns = indexCompany["table_" + newVal.id];
          } else {
            this.columns = indexCompany["table_default"];
          }
        }
      },
    },
    deep: true,
    immediate: true,
  },
  mounted() {},
  methods: {
    delete_batch() {
      // 批量删除设备
      //  批量删除
      if (!this.choose.length) {
        this.$message({
          type: "warning",
          message: "请先选择设备",
        });
        return;
      }
      this.$confirm("此操作将永久删除该设备, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: this.choose,
          };
          batchDeleteDevice(params).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.message,
              });
              this.search_list();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getCurrentRow(row) {
      this.templateSelection = row;
    },
    search_list() {
      this.page = 1;
      this.pageSize = 10;
      this.total = 0;
      this.get_list();
    },
    export_out() {},
    import_btn() {},
    // 页数
    currentChange(e) {
      this.page = e;
      this.get_list();
    },
    // 分页
    sizeChange(e) {
      this.pageSize = e;
      this.get_list();
    },
    get_list() {
      let params = {
        page_size: this.pageSize,
        page_num: this.page,
        third_id: this.row.id,
      };
      this.tableData = [];
      getDeviceList(params).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data.device_push_info.map((_f, _i) => {
            this.total = res.data.total;
            return {
              ..._f,
              index: _i + 1,
              method: _f.method == 1 ? "设备码添加" : "导入",
              methodCode: _f.method,
            };
          });
        }
      });
    },
    handleClose(done) {
      this.$emit("toggleShow", false);
      //   this.$refs.form.clearValidate();
    },
    // 选择设备
    handleSelectionChange(e) {
      this.choose = e.map((_f) => {
        return _f.id;
      });
    },
    add() {
      let param = {
        sn: this.templateSelection.sn,
        method: this.templateSelection.methodCode,
        third: this.row.id,
      };

      addThirdDevice(param).then((res) => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            // message: "设备添加成功！",
            message: this.$t("dialog.userList.add_success_info"),
            duration: 2000,
          });
          this.$emit("toggleShow", false);
          this.$emit("refush");
        } else {
          this.$message({
            type: "warning",
            message: res.msg,
            duration: 2000,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btns {
  justify-content: center;
  .btn {
    width: 180px;
    height: 32px;
  }
  .save {
    background-color: $main_color;
    border-color: $main_color;
    margin-left: 30px;
  }
  .cancel {
    border-color: $main_color;
    background-color: #fff;
    color: $main_color;
  }
}
.form {
  justify-content: center;
}
</style>
